import $ from 'jquery';
import { getStatePure, modifyState } from '~src/state';
import { titleCase } from '~core/text';
import { Howl } from 'howler';
import { triggerStateChangedRequest } from '~core';

let sound;

$('body').on('click', '#editor-sidebar-backTo-video-from-music', () => {
  if (sound) {
    sound.stop();
  }
});

export const displaySidebarMusic = () => {
  const videoMediaFiles = getStatePure('videoMediaFiles');
  const currentSoundtrackId = getStatePure('soundtrackId');

  const musicFiles = videoMediaFiles.music ?? [];

  let html = '';
  for (const musicFile of musicFiles) {
    const cleanName = titleCase(
      musicFile.id.replace('.mp3', '').replace('-', ' ').replace('/', ' / ')
    );

    html += `<div class="row mb-3 row-music-file mr-1 ml-1 pt-2 pb-2 rounded ${
      currentSoundtrackId === musicFile.id ? 'active' : ''
    }" data-animation-play-music="${musicFile.id}">
      <div class="col-3"><button style="min-width: 65px;" class="btn btn-sm btn-primary rounded-pill music-file-play"><span class="to-play">Ascolta</span><span class="playing"><div class="spinner-grow spinner-grow-sm text-success" role="status"></div></span></button></div>
      <div class="col text-left">${cleanName}</div>
      </div>`;
  }

  $('#editor-sidebar-music-files').html(html);
  $('body').off('click', '[data-animation-play-music]');
  $('body').on('click', '[data-animation-play-music]', (event) => {
    event.preventDefault();

    $('[data-animation-play-music]').removeClass('active playing');
    $(event.currentTarget).children('.music-file-play').innerText = 'Pausa';

    const musicId = $(event.currentTarget).data('animation-play-music');
    $(event.currentTarget).addClass('active playing');
    if (sound) {
      sound.stop();
    }
    const soundtrackUrl = `${process.env.GIOTTO_VIDEO_CDN}/media/music/${musicId}`;

    sound = new Howl({
      src: [soundtrackUrl],
    });

    const previewTime = 10000;
    const soundId = sound.play();
    sound.fade(0, 1, 2000, soundId);
    sound.fade(1, 0, previewTime, soundId);

    setTimeout(() => {
      sound.stop();
      $(event.currentTarget).removeClass('playing');
    }, previewTime);

    modifyState('soundtrackId', musicId);
    modifyState('soundtrackUrl', soundtrackUrl);
    triggerStateChangedRequest();
  });
};
